import { useGetDossierBetrokkenTreinenById } from "@/entities/betrokken-treinen";

type DuplicateValidation = {
    isDuplicate: boolean;
    duplicateSource: "dossier" | "spoorweb";
};

export function useValidateDuplicateTrain(dossierId: string) {
    const { data: treinen = [] } = useGetDossierBetrokkenTreinenById(dossierId);

    return (treinNummer: number, excludeId?: number): DuplicateValidation => {
        // When editing an existing train (a spoorweb train with isRelevant false), pass its ID to exclude it from duplicate checks
        const duplicate = treinen.find((trein) => trein.treinNummer === treinNummer && trein.id !== excludeId);
        return { isDuplicate: !!duplicate, duplicateSource: duplicate?.isRelevant ? "dossier" : "spoorweb" };
    };
}
